import { grey } from "@material-ui/core/colors";

// Styled inline (not via a class) so the emphasis survives the email/PDF
// renderers that strip `<style>`/classes.
export const UNRESOLVED_VARIABLE_HTML = `<span style="color: ${grey[500]}; text-decoration: underline">variable is unresolved</span>`;
